export default __webpack_public_path__ + "static/media/poster-appointHours.60313781.png";